export class PagerButton extends Autodesk.Viewing.UI.Button {
	public constructor(id: string, up: boolean, public floorLevel: number) {
		super(id);

		this.icon.innerHTML = "&nbsp;";

		this.addClass(`be-toolbar-pager-${up ? "up" : "down"}`);
		this.setDisplay(floorLevel.toString());
	}

	public set active(value: boolean) {
		if (value) {
			this.setState(Autodesk.Viewing.UI.Button.State.ACTIVE);
		} else {
			this.setState(Autodesk.Viewing.UI.Button.State.INACTIVE);
		}
	}
}
